import React from 'react';
import { connect } from 'react-redux';
import { apiActions, poppinFormActions } from '../../../actions';
import { mutedClick } from '../../design/utilities'
import { PoppinForm as PoppinFormView } from '../../design/Episode/PoppinForm';
import { goToLoginWithAction, isLogged} from '../helpers';

class PoppinForm extends React.Component {

  onKeyUp = (event) => {
    if (event.key === 'Enter') {
      this.submit();
    } else if (event.key === 'Escape') {
      this.props.poppinFormClose();
    } else {
      document.getElementById('poppinFormBodyInput').classList.remove('red');
    }
  };

  okOnClick = (event) => {
    event.preventDefault();
    this.submit();
  };

  submit() {
    if (!this.props.body) {
      document.getElementById('poppinFormBodyInput').classList.add('red');
    } else {
      this.props.poppinFormSend(this.props);
    }
  }

  render = () => (
    this.props.opened
      ? <PoppinFormView  {...this.props} onKeyUp={this.onKeyUp} okOnClick={this.okOnClick} />
      : null
  );
}

const mapState = (state, ownProps) => ({
  opened: state.poppinForm.pageId === ownProps.currentPageId,
  t: I18n.t('landing.poppinForm'),
  ...state.poppinForm
});

const mapDispatch = (dispatch, ownProps) => ({
  modalOnClick: mutedClick,
  onChange: (event) => { dispatch(poppinFormActions.poppinFormBodySet(event.target.value)) },
  cancelOnClick: () => { dispatch(poppinFormActions.poppinFormClose()) },
  poppinFormClose: () => { dispatch(poppinFormActions.poppinFormClose()) },
  poppinFormOpen: (pageId, posX, posY, body) => { dispatch(poppinFormActions.poppinFormOpen(pageId, posX, posY, body)) },
  poppinFormSend: (props) => { dispatch(apiActions.poppinFormSend(props)) }
});

export default connect(mapState, mapDispatch)(PoppinForm);